<template>
  <div class="whatwedo">
    <b-container class="mt-top text-left prl-outside">
      <b-row>
      	<b-col cols="8" class="p-0">
      		<b-col class="col-12 p-0 mb-3">
      			<img :src="require(`@/assets/img/GERA_Was-wir-tun_Pic_Hotel-Kitzhof1.jpg`)"/>
	  	  		<div class="hotspot w-100 p-2">
	  	  			<div class="hotspot-inlay">
	  	  				<h5 class="fw800 mb-3">{{$t('title1')}}</h5>
		  	  			<p class="fs-auto m-0">{{$t('text1')}}</p>
					</div>
	  	  		</div>
      		</b-col>
      		<b-row class="p-0 m-0">
		 		<b-col cols="6" class="p-0 pr-2">
	      			<img :src="require(`@/assets/img/GERA_Was-wir-tun_Pic2.jpg`)"/>
		  	  		<div class="hotspot p-2 pwc8">
  			  			<div class="hotspot-inlay">
							<h5 class="fw800 mb-3">{{$t('title2')}}</h5>
							<p class="fsm-auto lh-auto m-0">{{$t('text2')}}</p>
							</div>
		  	  		</div>
		 		</b-col>
	  	  		<div class="col-6 p-0 pl-2">
	      			<img :src="require(`@/assets/img/GERA_Was-wir-tun_Atmos3.jpg`)"/>
		  	  		<div class="hotspot p-2 mr-4 pwc8" style="left:8px;">
		  	  			<div class="hotspot-inlay">
		  	  				<h5 class="fw800 mb-3">{{$t('title3')}}</h5>
		  	  				<p class="fsm-auto lh-auto m-0">{{$t('text3')}}</p>
						</div>
		  	  		</div>
	  	  		</div>
	      	</b-row>
      	</b-col>
  		<b-col cols="4" class="p-0 pl-3">
   			<img :src="require(`@/assets/img/GERA_Was-wir-tun_Pic4.jpg`)" class="w-100 phc3"/>
  	  		<div class="hotspot ml-3 p-2 pb-0 phc3">
  	  			<div class="hotspot-inlay">
  	  				<h5 class="fw800 mb-3">{{$t('title2')}}</h5>
  	  				<p class="fs-auto m-0">{{$t('text2')}}</p>
				</div>
  	  		</div>
  		</b-col>
      </b-row>
    </b-container>

    <div class="big-text text-left">{{$t('wedo')}}</div>
  </div>
</template>
<script>
export default {
	name: 'Whatwedo',
	data () {
		return {
			wedos: [
				{ picture: 'GERA_Was-wir-tun_Pic1.jpg', title: 'Hoteleinrichtung', text: 'Luxushotels rund um die Welt, gleich ob das mit modernem Charme überzeugende Hilton, das traditionelle Haas Haus in Wien, oder das Mövenpick in Paris, wir konnten bei all diesen exklusiven Namen unser Können unter Beweis stellen.' },
				{ picture: 'GERA_Was-wir-tun_Pic2.jpg', title: 'Schiffsausstattung', text: 'Moderne Luxus- und Megayachten zählen ebenfalls zu unserer Spielwiese. Auf so ein Boot kommt man in der Regel in seinem Leben nicht – bei uns schon, wenn auch zum Arbeiten in den renommiertesten Werften der Welt.' },
				{ picture: 'GERA_Was-wir-tun_Pic3.jpg', title: 'Öffentliche Gebäude', text: 'Beim Betreten von Empfangshallen und öffentlich zugänglichen Räumen ist es wie bei Menschen – der allererste Eindruck zählt. Gerade bei großen Foyers ist es daher besonders wichtig einen guten ersten Eindruck zu machen: Viel Liebe zu Details und präzise Ausrichtung sind nötig, um so weitläufige Flächen ins richtige Licht zu rücken.' },
				{ picture: 'GERA_Was-wir-tun_Pic4.jpg', title: 'Schiffsausstattung', text: 'Moderne Luxus- und Megayachten zählen ebenfalls zu unserer Spielwiese. Auf so ein Boot kommt man in der Regel in seinem Leben nicht – bei uns schon, wenn auch zum Arbeiten in den renommiertesten Werften der Welt.' }
			]
		}
	}
}
</script>
<style scoped>
h5 {
	overflow: hidden;
	text-overflow: ellipsis;
}
.whatwedo .row img {
	width:100%;
}
.hotspot {
	opacity: 0;
	width:calc(100% - 17px);
	display: flex;
	height:100%;
	top:0;
	left:0;
	position:absolute;
	background-color: rgba(0,0,0,0.35);
	color:white;
	text-align:left;
	transition: opacity 0.5s ease-in-out;
	overflow: auto;
}
.hotspot:hover {
	opacity: 1;
}
.hotspot-inlay {
	display: inline-block;align-self: flex-end;width:100%;height:auto;
}
.pr15 {
	padding: 0 15px 0 0 !important;
}
.pl15 {
	padding: 0 0 0 15px !important;
}
.pr30 {
	padding: 0 30px 0 0 !important;
}
.pt30 {
	padding: 30px 0 0 0 !important;
}
.mb30 {
 	margin: 0 0 30px 0;
}
.ml15 {
 	margin: 0 0 0 15px;
}
.phc3 {
	 height:calc(100% - 3px) !important;
}
.pwc8 {
	 width:calc(100% - 8px) !important;
}
@media only screen and (max-width: 1400px) {
	.phc3 {
		height:100% !important;
	}
}
</style>
<i18n>
	{
		"de": {
			"wedo": "Was wir tun",
			"globalText": "Unser guter Ruf eilt uns nicht nur voraus, sondern bringt uns für unsere Montageeinsätze an die spannendsten Orte der Welt.",
			"title1": "Hoteleinrichtung",
 			"text1": "Luxushotels rund um die Welt, gleich ob das mit modernem Charme überzeugende Hilton, das traditionelle Haas Haus in Wien, oder das Mövenpick in Paris, wir konnten bei all diesen exklusiven Namen die Einrichtungen installieren und unser Können unter Beweis stellen.",
			"title2": "Schiffsausstattung",
			"text2": "Moderne Luxus- und Megayachten zählen ebenfalls zu unserer Spielwiese. Auf so ein Boot kommt man in der Regel in seinem Leben nicht – bei uns schon, wenn auch zum Arbeiten in den renommiertesten Werften der Welt.",
			"title3": "Öffentliche Gebäude",
			"text3": "Beim Betreten von Empfangshallen und öffentlich zugänglichen Räumen ist es wie bei Menschen – der allererste Eindruck zählt. Gerade bei großen Foyers ist es daher besonders wichtig, dass das Tischlerhandwerk einwandfrei umgesetzt wird, um mit den Montagen einen guten ersten Eindruck zu machen: Viel Liebe zu Details und präzise Ausrichtung sind nötig, um so weitläufige Flächen ins richtige Licht zu rücken."
		},
		"en": {
			"wedo": "What we do",
			"globalText": "Our good reputation not only speaks for itself, but it brings us installation jobs in some of the most exciting places on earth.",
			"title1": "Hotel facilities",
 			"text1": "At exclusive hotels worldwide we have been able to prove what we can do whether it is the modern charm of the impressive Hilton, the traditional Haas Haus in Vienna or the Mövenpick in Paris.",
			"title2": "Interior installation and furnishings for ships",
			"text2": "Modern luxury yachts and mega-yachts are also part of our portfolio. Most people normally do not get on this sort of a boat once in their lifetime – but we do, even if it is only for work at some of the most prestigious shipyards in the world.",
			"title3": "Public buildings",
			"text3": "When you enter an entrance hall and publicly accessible rooms, the first impression is what counts just like when you meet people for the first time. Especially for large foyers, it is especially important to make a good first impression: a deep appreciation for details and precise positioning are necessary to show such extensive areas correctly."
		}
	}
</i18n>
